'use strict';

const braintree = require('./payment-gateway/braintree');
const spreedly = require('./payment-gateway/spreedly');

module.exports = {
	init: ({ spreedlyConfig, braintreeConfig, onSubmitting }) => {
		if (!('gateway' in window.iq)) {
			console.error(new Error('gateway config error: window.iq.gateway not detected'));
			return;
		}

		if (window.jQuery('#paymentToken').length === 0) {
			console.error(new Error('Missing hidden form input #paymentToken'));
			return;
		}

		if (window.iq.gateway === 'braintree') {
			braintree.init({ ...braintreeConfig, onSubmitting });
		} else if (window.iq.gateway === 'spreedly') {
			//some pages will call init() repeatedly because braintree needs name/amounts in init for gpay/apay/etc.
			if (window.iq.spreedly_initialized) {
				return;
			}
			spreedly.init({ ...spreedlyConfig, onSubmitting });
			window.iq.spreedly_initialized = true;
		}
	},
	//for last minute config changes before display/submit
	update: (options) => {
		if (window.iq.gateway === 'braintree') {
			braintree.update(options);
		} else if (window.iq.gateway === 'spreedly') {
			spreedly.update(options);
		}
	},
	//trigger card collection/tokenization, which will eventually submit the form
	tokenize: (options) => {
		if (window.iq.gateway === 'braintree') {
			braintree.tokenize(options);
		} else if (window.iq.gateway === 'spreedly') {
			spreedly.tokenize(options);
		}
	}
};
